import React from "react";
import securityImage from "../../../assets/security.jpg";
import { Link } from "react-router-dom";

const EnsureSecurity = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="erp-integration-ensure-security-wrapper">
      <div className="security-details">
        <div className="row align-items-center justify-content-between">
          <div className="col-12 col-md-6 col-lg-8 col-xl-6">
            <div className="partnership__infos">
              <h2>How We Ensure Security in ERP Integration</h2>
              <p className="fs-lead my-4">
                Our ERP integration services prioritize data security and
                privacy. We use secure APIs, data encryption, and multi-layered
                authentication processes to protect sensitive business
                information. We also ensure compliance with industry
                regulations, implementing role-based access controls to ensure
                only authorized personnel can access critical information.
              </p>
              <div className="mt-10x">
                <Link
                  to="/contact-us"
                  className="link-btn btn link-btn--primary"
                  onClick={scrollHeader}
                >
                  <span>Contact Us</span>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div
              className="justify-content-center d-flex"
              style={{ position: "relative", opacity: 1, transform: "none" }}
            >
              <img src={securityImage} alt="security" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnsureSecurity;
